import { forwardRef } from 'react'
import { useInputMultiSelectContext } from '../../input-multi-select'
import type {
  InputMultiSelectFieldProps,
  InputMultiSelectScopedProps,
} from '../../input-multi-select.types'
import { InputMultiSelectFieldVariants } from './index.styles'

export const InputMultiSelectField = forwardRef<
  HTMLInputElement,
  InputMultiSelectFieldProps
>(
  (
    {
      __scopeInputMultiSelect,
      onFocus,
      onBlur,
      ...props
    }: InputMultiSelectScopedProps<InputMultiSelectFieldProps>,
    ref
  ) => {
    const { disabled, readonly, size, isActive, setActive } =
      useInputMultiSelectContext(
        'InputMultiSelectField',
        __scopeInputMultiSelect
      )

    const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
      setActive(true)
      onFocus?.(event)
    }
    const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
      setActive(false)
      onBlur?.(event)
    }

    return (
      <input
        {...props}
        ref={ref}
        disabled={disabled}
        readOnly={readonly}
        placeholder="Placeholder is hidden"
        className={InputMultiSelectFieldVariants({
          disabled,
          readOnly: readonly,
          isActive,
          size,
        })}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    )
  }
)

InputMultiSelectField.displayName = 'InputMultiSelectField'
